export default __webpack_public_path__ + "static/media/checkbox-checked-yono.8a6f6cbd.png";